// extracted by mini-css-extract-plugin
module.exports = {"page":"LicenceExpiredPage_page__2hsQ8"};